import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, Paper } from '@mui/material';
import { useIsAuthenticated } from '@azure/msal-react';

const PageHome: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <section role="main"
        className="section section-content section-infraplannen-home section-underline-home">
        <div className="container">
          <div className="row">
            <div className="col-xxl-7 col-xl-6 col-lg-6 hidden-sm"></div>
            <div className="col-xxl-5 col-xl-6 col-lg-6 col-sm-12">
              
              <Paper sx={{ width: '100%', padding: '20px', margin: '80px auto 0px' }}>
                <h1>Deel uw plannen met stakeholders</h1>
                <p className="header-sub-title">
                  Welkom bij hét landelijke platform waar netbeheerders samen met gemeenten, provincies, waterschappen en andere organisaties, efficiënt hun strategische plannen delen en afstemmen.
                </p>
                <p>Stem strategische en tactische werkpakketten multidisciplinair af, beperk publieke overlast en verhoog efficiëntie.</p>

                {!isAuthenticated ? (
                  <Button variant="contained" color="secondary" onClick={() => navigate('/inloggen')}>
                    Inloggen
                    <Icon>chevron_right</Icon>
                  </Button>
                ) : (
                  <Button variant="contained" color="secondary" onClick={() => navigate('/plannen')}>
                    Bekijk alle plannen
                    <Icon>chevron_right</Icon>
                  </Button>
                )}

                <span style={{ marginLeft: '10px' }}>
                  <Button variant="text" color="secondary" onClick={ () => navigate('/over') }>
                    Bekijk video
                    <Icon>chevron_right</Icon>
                  </Button>
                </span>
              </Paper>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageHome;